import * as React from "react";

interface IProps {
    centerId: number
}

class Kpd extends React.Component<IProps, {}> {
    render = () => {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12">
                        Coming soon...
                    </div>
                </div>
            </div>
        )
    }
}

export default Kpd;